const debug = document.getElementById('yii-debug-toolbar');
if (!debug) {
    document.addEventListener('contextmenu', e => {
        if (e.target.tagName === 'IMG') {
            e.preventDefault()
        }
    });
}

